// Utility to prefetch route components
export const prefetchRoute = (routeName) => {
    const routes = {
        home: () => import('../pages/Home'),
        impressum: () => import('../pages/Impressum'),
        challenger: () => import('../pages/Challenger'),
        address: () => import('../pages/Address'),
        gallery: () => import('../pages/GalleryPage'),
        galleryAlbum: () => import('../pages/GalleryAlbumPage')
    };

    if (routes[routeName]) {
        routes[routeName]();
    }
};